import React from "react";
import Paper from "material-ui/Paper";
import Grid from "material-ui/Grid";
import Typography from "material-ui/Typography";
import Card, { CardContent } from "material-ui/Card";
import { withStyles } from "material-ui/styles";
import {
  metersToFeet,
  getFormattedNumber,
  getWiremapImageUrl
} from "../../../../../../common/utils";
import { infoData, infoData2 } from "./infoenum";
import styles from "./styles";

class WiremapSubtest extends React.Component {
  constructor(props) {
    super(props);
  }

  lengthUnitConverter = length => {
    const { chartMeasurementUnit } = this.props;
    if (chartMeasurementUnit === "feet") {
      return metersToFeet(length);
    }
    return getFormattedNumber(length);
  };

  render() {
    const {
      classes,
      translate,
      results,
      chartMeasurementUnit,
      subtestResultsDisplay,
      subtest,
      subtestRes
    } = this.props;

    let wiremapImage = getWiremapImageUrl(results.data.subtests[subtest], chartMeasurementUnit);

    return (
      <Grid container spacing={0}>
        {wiremapImage && (
            <img
              alt=""
              src={wiremapImage}
              className={classes.image}
            />
          )}
        {results.data.subtests[subtest] &&
          results.data.subtests[subtest].info &&
          infoData2.find(o => o.name === results.data.subtests[subtest].info) ==
            undefined && (
            <Grid xs={12} className={classes.info_div}>
              <Typography color="inherit" className={classes.t_tar_no2}>
                {translate("Length") + " : "}
              </Typography>
              <Typography color="inherit" className={classes.t_tar_no2}>
                {/* {results.data.subtests[subtest].length.toFixed(2) + "m"} */}
                {results.data.subtests[subtest]
                  ? chartMeasurementUnit == "feet"
                    ? this.lengthUnitConverter(
                        results.data.subtests[subtest].length
                      )
                    : this.lengthUnitConverter(
                        results.data.subtests[subtest].length
                      ) + "m"
                  : "-"}
              </Typography>
            </Grid>
          )}
        <Grid xs={12} className={classes.info_div}>
          <Typography color="inherit" className={classes.t_tar_no2}>
            {translate("info") + " : "}
          </Typography>
          <Typography color="inherit" className={classes.t_tar_no2}>
            {results.data.subtests[subtest] &&
              results.data.subtests[subtest].info &&
              translate(
                infoData.find(
                  o => o.name === results.data.subtests[subtest].info
                ).id
              )}
          </Typography>
        </Grid>
      </Grid>
    );
  }
}

export default withStyles(styles)(WiremapSubtest);
